<template>
    <div class="color">
        <div class="colorBox">
            <el-color-picker size="small" v-model="colorObj.color[0].item"></el-color-picker>
            <span @click="updateColor">重置</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        colorObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {};
    },
    methods: {
        updateColor() {
            this.colorObj.color[0].item = this.colorObj.default[0].item;
        }
    }
};
</script>

<style scoped lang="scss">
.color {
    margin: 10px 0;
}

.colorBox {
    display: flex;
    align-items: center;

    span {
        margin-left: 10px;
        color: #999999;
    }
}
</style>